export const setBackgroundByClass = (className: string, color: string) =>
  (document.querySelector(`.${className}`) as HTMLElement | null)?.style.setProperty('background-color', color);
